import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectCPMFTrackingForecastMembers,
  setMembers as setMembersRedux,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import useMemberOptions from './useMemberOptions';

export default function useMembers() {
  const { members } = useMemberOptions();
  const selectedMembers: number[] = useSelector(selectCPMFTrackingForecastMembers);
  const setSelectedMembers = (newMembers) => store.dispatch(setMembersRedux(newMembers));

  return { members, selectedMembers, setSelectedMembers };
}
